import { filter } from 'lodash';
import * as t from './actionTypes';

const initialState = {
    files: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.CLEAR_FILES:
            return Object.assign({}, state, {
                files: []
            });
        case t.LOAD_FILES:
            return Object.assign({}, state, {
                files: action.payload
            });
        default:
            return state
    }
}